import React, { useState, useEffect } from 'react';
import { Card, Col, Row, Stack } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import FileUpload from 'components/Common/FileUpload';
import ClosingDocDetail from './ClosingDocDetail';
import {DocDetail} from "states/initialState";
import { getRequiredFiles } from 'service';
import { useParams } from 'react-router-dom';
import useFetch from 'use-http';
import {useAuth0} from "@ondeck/silkworm";

type AppParams = { businessId: string };

const ClosingDocs = () => {
  const intl = useIntl();
  const { businessId } = useParams<AppParams>();
  const { user } = useAuth0();

  const hook = useFetch(window.env.REACT_APP_PARTNER_ORCHESTRATOR, {
    cacheLife: 5000,
    retryDelay: 30000,
    headers: {
      partnerContactEmail: `${user.email}`
    }
  });

  const [requiredFiles, setRequiredFiles] = useState<DocDetail[]>([]);

  function hasRequiredDocuments(docs) {
    return docs.filter(doc => doc.status === "Requested").length > 0;
  }

  useEffect(() => {
    getRequiredFiles(hook, businessId).then((response: any) => {
      setRequiredFiles(response.documents);
    });
  }, []);

  return (
    <Card className="shadow-sm">
      <Row className="m-0">
        <Col xs={12} className="p-4 col-md">
          <div className="h2 fw-400 text-md-start text-center">
            <FormattedMessage id="closingDocs.missingDocs.heading" />
          </div>
          <div className="bg-light p-3">
            <div className="h2 fw-400">
              <div className="fs-3 fw-medium text-md-start text-center mb-3">
                <FormattedMessage id="closingDocs.heading" />
              </div>
              <FileUpload businessId={businessId} disableSelectFileButton={!hasRequiredDocuments(requiredFiles)} />
              <Stack className="fs-5 mt-3" gap={3}>
                <hr className="mb-1"/>
                <FormattedMessage id="closingDocs.p1"/>
                <span>
                  <FormattedMessage id="closingDocs.p2.text"/>
                  <a target="_blank" className="ms-1" href={intl.formatMessage({ id: 'closingDocs.p2.href' })}>
                    <FormattedMessage id="closingDocs.p2.link"/>
                  </a>
                </span>
                <FormattedMessage id="closingDocs.p3"/>
                <hr className="mb-1"/>
                <FormattedMessage id="closingDocs.p4"/>
                <span>
                  <FormattedMessage id="closingDocs.p5.text"/>
                  <a className="ms-1" href={`mailto: ${intl.formatMessage({ id: 'closingDocs.p5.link' })}`}>
                    <FormattedMessage id="closingDocs.p5.link"/>
                  </a>
                </span>
              </Stack>
            </div>
          </div>
        </Col>
        <Col xs={12} md={4} className="p-4">
          {requiredFiles && (
            <>
              <ClosingDocDetail docs={requiredFiles?.filter(doc => doc.status ===  "Requested")}/>
              <ClosingDocDetail docs={requiredFiles?.filter(doc => doc.status ===  "Rejected")} className="border-top mt-4 pt-3"/>
              <ClosingDocDetail docs={requiredFiles?.filter(doc => doc.status ===  "Accepted")} className="border-top mt-4 pt-3"/>
            </>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default ClosingDocs;
